import { render, staticRenderFns } from "./AlertDiscount.vue?vue&type=template&id=25c7223a&scoped=true&"
import script from "./AlertDiscount.vue?vue&type=script&lang=ts&"
export * from "./AlertDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDiscount.vue?vue&type=style&index=0&id=25c7223a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7223a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c7223a')) {
      api.createRecord('25c7223a', component.options)
    } else {
      api.reload('25c7223a', component.options)
    }
    module.hot.accept("./AlertDiscount.vue?vue&type=template&id=25c7223a&scoped=true&", function () {
      api.rerender('25c7223a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/ob1/component/AlertDiscount.vue"
export default component.exports